module.exports = __webpack_public_path__ + "img/smartphone.a3cd38da.jpg";